(function () {
  const DRAWER_SELECTOR = 'cart-drawer';
  const DRAWER_URL = '/cart?view=drawer';
  let isUpdating = false;

  const getDrawer = () => document.querySelector(DRAWER_SELECTOR);

  const openDrawer = (drawer) => {
    if (!drawer) {
      console.error('Cart drawer element not found');
      return;
    }
    console.log('Opening cart drawer');
    // Use the custom element's show() method
    if (typeof drawer.show === 'function') {
      drawer.show();
    } else {
      // Fallback to manual class manipulation
      drawer.classList.add('is-open');
      drawer.classList.remove('drawer--center-body');
      drawer.setAttribute('open', 'true');
    }
  };

  const initCartSwiperNav = () => {
    console.log('--- initCartSwiperNav: Start ---');
    const swiperContainer = document.querySelector('.cart-drawer__complementary-products .complementary-products__swiper');
    const prevButton = document.querySelector('.cart-drawer__complementary-products .cart-swiper-nav-prev');
    const nextButton = document.querySelector('.cart-drawer__complementary-products .cart-swiper-nav-next');

    if (!swiperContainer) {
      console.log('--- initCartSwiperNav: Swiper Container NOT found ---');
      return;
    }
    if (!prevButton || !nextButton) {
      console.log('--- initCartSwiperNav: Nav buttons NOT found ---');
      return;
    }
    console.log('--- initCartSwiperNav: Elements found ---', { swiperContainer, prevButton, nextButton });

    // Check if valid swiper custom element
    if (swiperContainer.tagName === 'SWIPER-CONTAINER') {
       if (!swiperContainer.swiper) {
         console.log('--- initCartSwiperNav: Swiper property not yet available, waiting... ---');
       }
    }

    // Wait for swiper to be ready
    let attempts = 0;
    const checkSwiper = setInterval(() => {
      attempts++;
      if (swiperContainer.swiper) {
        clearInterval(checkSwiper);
        console.log('--- initCartSwiperNav: Swiper instance ready ---');

        const swiper = swiperContainer.swiper;

        // Remove existing listeners to prevent duplication (cloning is a quick way)
        const newPrev = prevButton.cloneNode(true);
        const newNext = nextButton.cloneNode(true);
        prevButton.parentNode.replaceChild(newPrev, prevButton);
        nextButton.parentNode.replaceChild(newNext, nextButton);
        
        // Add new listeners
        newPrev.addEventListener('click', (e) => {
          e.preventDefault();
          console.log('--- Prev Button Clicked ---');
          swiper.slidePrev();
        });

        newNext.addEventListener('click', (e) => {
          e.preventDefault();
          console.log('--- Next Button Clicked ---');
          swiper.slideNext();
        });

        // Update button states
        function updateNavButtons() {
          if (swiper.isBeginning) {
            newPrev.classList.add('swiper-button-disabled');
            newPrev.setAttribute('disabled', 'disabled');
          } else {
            newPrev.classList.remove('swiper-button-disabled');
            newPrev.removeAttribute('disabled');
          }

          if (swiper.isEnd) {
            newNext.classList.add('swiper-button-disabled');
            newNext.setAttribute('disabled', 'disabled');
          } else {
            newNext.classList.remove('swiper-button-disabled');
            newNext.removeAttribute('disabled');
          }
        }

        // Initial update
        updateNavButtons();

        // Update on slide change
        swiper.on('slideChange', updateNavButtons);
      } else if (attempts > 50) {
        console.log('--- initCartSwiperNav: Timed out waiting for swiper ---');
        clearInterval(checkSwiper);
      }
    }, 100);
  };


  const loadCartRecommendations = () => {
    console.log('--- loadCartRecommendations: Start ---');
    const container = document.getElementById('cart-drawer-recommendations');
    if (!container) {
      console.log('--- loadCartRecommendations: Container NOT found ---');
      return;
    }

    const productId = container.dataset.productId;
    // If no product is in the cart, clear recommendations or handle empty state
    if (!productId) {
      console.log('--- loadCartRecommendations: No product ID, clearing container ---');
      container.innerHTML = ''; 
      return;
    }

    // Add timestamp to prevent caching of recommendations
    const url = `${container.dataset.url}&product_id=${productId}&t=${Date.now()}`;
    console.log('--- loadCartRecommendations: Fetching URL ---', url);
    
    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.text();
      })
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.cart-drawer__complementary-products');

        if (recommendations && recommendations.innerHTML.trim().length) {
          console.log('--- loadCartRecommendations: Found valid recommendations content ---');
          container.innerHTML = recommendations.innerHTML;
          
          // Initialize swiper for the new content
          requestAnimationFrame(() => {
             initCartSwiperNav();
          });
          
          document.dispatchEvent(new CustomEvent('cart-recommendations:loaded'));
        } else {
          console.log('--- loadCartRecommendations: No recommendations content found ---');
          container.innerHTML = '';
        }
      })
      .catch(e => {
        console.error('Error fetching recommendations:', e);
        container.innerHTML = ''; // Clear on error
      });
  };

  const replaceDrawerContent = (html) => {
    const drawer = getDrawer();
    if (!drawer) {
      console.error('Cart drawer element not found in DOM');
      return;
    }

    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(html, 'text/html');
    const freshContent = parsedDocument.querySelector('.cart-drawer__content');
    const currentContent = drawer.querySelector('.cart-drawer__content');

    if (freshContent && currentContent) {
      currentContent.innerHTML = freshContent.innerHTML;
      console.log('Cart drawer content updated');
      loadCartRecommendations(); // Fetch recommendations for the new cart state
    } else {
      console.error('Could not find drawer content elements');
    }

    openDrawer(drawer);
  };

  const updateHeaderCart = () => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        document.querySelectorAll('cart-count').forEach(el => {
          el.innerText = cart.item_count;
        });
        document.querySelectorAll('cart-dot').forEach(el => {
          if (cart.item_count > 0) {
            el.classList.add('is-visible');
          } else {
            el.classList.remove('is-visible');
          }
        });
      })
      .catch(e => console.error('Error updating header cart:', e));
  };

  const refreshDrawer = () => {
    console.log('Refreshing cart drawer...');
    return fetch(DRAWER_URL, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then((response) => {
        console.log('Drawer refresh response:', response.status);
        return response.text();
      })
      .then((html) => {
        replaceDrawerContent(html);
        updateHeaderCart();
      })
      .catch((error) => {
        console.error('Unable to refresh cart drawer', error);
      });
  };

  const handleSubmit = (event) => {
    const form = event.target;

    // Skip if not a form element
    if (!form || form.nodeName !== 'FORM') {
      return;
    }

    // Check if it's the sticky bar form
    const formId = form.getAttribute('id') || '';
    const isStickyForm = formId.includes('product-form-sticky');

    // Also check if form has sticky-cart-form class
    const hasStickyClass = form.classList.contains('sticky-cart-form');

    // If it's NOT the sticky form, let the theme handle it normally.
    if (!isStickyForm && !hasStickyClass) {
      return;
    }

    console.log('Sticky form intercepted:', formId);

    // For Sticky Form: Manual AJAX Submission
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (isUpdating) {
      return;
    }

    isUpdating = true;
    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');

    // Store original button text
    let originalButtonText = '';

    // Set button to loading state
    if (submitButton) {
      originalButtonText = submitButton.innerHTML;
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.classList.add('loading');

      // Change button text to show feedback
      // const loadingText = submitButton.dataset.loadingText || 'Adding...';
      // submitButton.innerHTML = loadingText;
      submitButton.innerHTML = '<div class="loader-spinner-btn"></div>';
    }

    // Trigger theme's loading bar
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', {
      bubbles: true
    }));

    // Create FormData from the form
    const formData = new FormData(form);
    const variantId = formData.get('id');
    const quantity = parseInt(formData.get('quantity') || '1', 10);

    console.log('Adding to cart:', { variantId, quantity });

    if (!variantId) {
      console.error('No variant ID found in form');
      isUpdating = false;
      if (submitButton) {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('loading');
      }
      return;
    }

    // Shopify's cart API can accept both JSON and form data
    // Using URLSearchParams for better compatibility
    const params = new URLSearchParams();
    params.append('id', variantId);
    params.append('quantity', quantity);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: params.toString()
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((error) => {
            throw error;
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log('Product added to cart:', data);

        const drawer = getDrawer();
        if (!drawer) {
          console.error('Cart drawer not found');
          return;
        }

        // Listen for the drawer refresh completion
        const onRefreshed = () => {
          console.log('Cart drawer refreshed, now opening...');
          openDrawer(drawer);
          updateHeaderCart();

          // End loading state
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', {
            bubbles: true
          }));

          drawer.removeEventListener('cart-drawer:refreshed', onRefreshed);
        };

        drawer.addEventListener('cart-drawer:refreshed', onRefreshed);

        // Trigger cart refresh event that the theme's CartDrawer listens to
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        // Fallback: open after timeout if event doesn't fire
        setTimeout(() => {
          drawer.removeEventListener('cart-drawer:refreshed', onRefreshed);
          refreshDrawer(); // Manual refresh if native event fails
        }, 500);
      })
      .catch((error) => {
        console.error('Unable to add item to cart', error);

        // End loading state on error
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', {
          bubbles: true
        }));

        if (error.description) {
          alert(error.description);
        } else if (error.message) {
          alert(error.message);
        }
      })
      .finally(() => {
        isUpdating = false;
        if (submitButton) {
          submitButton.removeAttribute('disabled');
          submitButton.removeAttribute('aria-busy');
          submitButton.classList.remove('loading');
          
          // Restore original button content
          submitButton.innerHTML = originalButtonText;
        }
      });
  };

  // Use Capture Phase to ensure we catch the sticky form before theme scripts
  document.addEventListener('submit', handleSubmit, true);

  // Listen for cart refresh events to update drawer content
  document.addEventListener('cart:refresh', () => {
     refreshDrawer();
  });

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCartSwiperNav();
      loadCartRecommendations();
    });
  } else {
    initCartSwiperNav();
    loadCartRecommendations();
  }
})();

// Cart Page - Add Note Toggle
(function () {
  const noteButton = document.querySelector('[data-cart-note-toggle]');
  if (!noteButton) return;

  const noteWrapper = document.querySelector('.cart-note-wrapper');
  if (!noteWrapper) return;

  noteButton.addEventListener('click', function () {
    const isVisible = noteWrapper.style.display !== 'none';
    noteWrapper.style.display = isVisible ? 'none' : 'block';
  });
})();